
import { onMounted, reactive, ref } from 'vue'
import Button from '@/components/elements/Button.vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import FormSelectField from '@/components/block/FormSelectField.vue'
import { axiosSetting } from '@/utils/axiosSetting'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  props: {
    answer: Number,
    answer_comment: String,
  },

  name: 'MypageLeaveInput',

  components: {
    Button,
    HeadingLv1,
  },

  setup(props: any) {
    const store = useStore()
    const router = useRouter()
    const state = reactive<any>({
      enableRequest: false,
      hasRequestableHospital: false,
      isLoading: true
    })

    const csrf = ref(
      document.querySelector('meta[name="csrf-token"]')!.getAttribute('content')
    )

    interface SelectObject {
      label: string
      value: string
      selected: boolean
    }

    const selectDefault = {
      label: '選択してください',
      value: '',
      selected: false
    }

    const confirm = () => {
        const ajax = axiosSetting('app', 'action')

        const params: any = {
          unsub_reason_id: props.answer,
          _token: csrf.value,
          token: state.token,
        }

        ajax
          .post('/api/v1/user_leave/unsub', params)
          .then((res) => {
            const ajax = axiosSetting('app', 'action')
            ajax
              .get('/logout?home=true')
              .then((res) => {
                console.log("logout success");
                store.commit('resetUserInfo');
                //router.replace('/mypage/leave/thanks');
                window.location.href = '/mypage/leave/thanks';
              })
              .catch((errors: any) => {
                console.log("logout error");
                store.commit('resetUserInfo');
                //router.replace('/mypage/leave/thanks');
                window.location.href = '/mypage/leave/thanks';
              })
          })
          .catch((errors: any) => {
            if (errors.response.data) {

              const errorInfo = errors.response.data
              Object.keys(errorInfo).forEach((key) => {
                // リダイレクト（パスワードが空の場合)
                if (key == 'redirect') {
                  // TODO: メッセージ追加
                  // リダイレクトする
                  router.push(errorInfo[key]);
                } else if (key == 'alert') {
                  alert(errorInfo[key]);
                }

              })
            }
          })
    }

    onMounted(() => {
      const getList = axiosSetting('app', 'page')

      if (props.answer == null) {
        router.push('/');
      }
    })

    return {
      csrf,
      state,
      FormSelectField,
      confirm,
    }
  }
}
